<template>
  <section class="definitive-return-show">
    <!-- Top Action Bar -->
    <div class="top-action-bar mb-4 d-print-none">
      <b-row class="align-items-center">
        <b-col
          cols="12"
          md="6"
        >
          <h2 class="page-title mb-0">
            <feather-icon
              icon="FileTextIcon"
              size="24"
              class="mr-2"
            />
            Bon de traitement anomalie #{{ voucher.id }}
          </h2>
          <p
            v-if="voucher.created_at"
            class="page-subtitle text-muted"
          >
            Créé le {{ formatFn(voucher.created_at) }} par {{ voucher.created_by_name || 'Système' }}
          </p>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="text-md-right"
        >
          <b-button
            variant="outline-secondary"
            :to="{ name: 'bon-retour-definitive-list' }"
          >
            Retour à la liste
          </b-button>
        </b-col>
      </b-row>
    </div>

    <!-- Main Content / Print Area -->
    <b-card
      id="voucher-print-area"
      class="voucher-card-printable"
    >
      <!-- Logo & Company Info Header -->
      <div class="printable-header mb-2">
        <b-row>
          <b-col cols="6">
            <img
              :src="logoSrc"
              alt="Logo"
              class="print-logo"
            >
          </b-col>
        </b-row>
      </div>

      <!-- Document Title and Company Box -->
      <b-row class="mb-2">
        <b-col cols="7">
          <div class="document-info">
            <h2 class="document-title">
              Bon de traitement anomalie
            </h2>
            <p class="mb-0">
              <strong>Date : </strong> {{ formatShortDate(voucher.created_at) }}
            </p>
            <p class="mb-0">
              <strong>Nombre de colis : </strong> {{ voucher.orders_count }}
            </p>
          </div>
        </b-col>
        <b-col cols="5">
          <div class="company-details-box">
            <p class="mb-0">
              <strong>Honesty Express : Société de livraison des colis</strong>
            </p>
            <p class="mb-0">
              <strong>Matricule fiscale : </strong> 0
            </p>
            <p class="mb-0">
              <strong>Adresse : </strong> Kairouan
            </p>
            <p class="mb-0">
              <strong>Téléphone : </strong> 24382005
            </p>
          </div>
        </b-col>
      </b-row>

      <!-- Main Orders Table -->
      <div class="table-container-printable">
        <table class="custom-print-table">
          <thead>
            <tr>
              <th>CODE</th>
              <th>EXPÉDITEUR</th>
              <th>GOUVERNORAT</th>
              <th>TEL</th>
              <th>DESTINATAIRE</th>
              <th>ADRESSE</th>
              <th>PRIX</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="order in voucher.orders"
              :key="order.id"
            >
              <td class="text-danger font-weight-bold">
                {{ order.id }}
              </td>
              <td>{{ order.supplier ? order.supplier.username : '-' }}</td>
              <td>{{ order.governorate || '-' }}</td>
              <td>{{ order.phone1 || '-' }}</td>
              <td>{{ order.name || '-' }}</td>
              <td>{{ order.locality || '-' }}</td>
              <td>{{ order.price_ttc }} DT</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Signature Section -->
      <div class="signature-section mt-5">
        <h4 class="signature-label">
          Signature
        </h4>
        <div class="signature-line" />
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import axios from 'axios'
import logoColor from '@/assets/images/logo/logo.png'

export default {
  components: {
    BRow, BCol, BCard, BButton,
  },
  data() {
    return {
      voucher: {
        orders: [],
      },
      isLoading: false,
      logoSrc: logoColor,
    }
  },
  created() {
    this.fetchVoucher()
  },
  methods: {
    async fetchVoucher() {
      this.isLoading = true
      try {
        const { data } = await axios.get(`/api/return-vouchers/definitive/detail/${this.$route.params.id}/`)
        this.voucher = data
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching definitive voucher detail', error)
      } finally {
        this.isLoading = false
      }
    },
    formatFn(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleString('fr-FR')
    },
    formatShortDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      const yr = d.getFullYear()
      const mo = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hr = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      const sec = String(d.getSeconds()).padStart(2, '0')
      return `${yr}-${mo}-${day} | ${hr}:${min}:${sec}`
    },
  },
}
</script>

<style lang="scss" scoped>
.definitive-return-show {
  background-color: #f8f8f8;
  padding: 2rem;

  .voucher-card-printable {
    border: none;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    background-color: white;
    padding: 1cm;
    max-width: 21cm;
    margin: 0 auto;
  }

  .print-logo {
    max-height: 80px;
    margin-bottom: 2rem;
  }

  .document-title {
    font-weight: 700;
    font-size: 1.8rem;
    margin-bottom: 1rem;
    color: #2c3e50;
  }

  .company-details-box {
    border: 1.5px solid #000;
    padding: 15px;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #000;
  }

  .table-container-printable {
    margin-top: 2rem;
  }

  .custom-print-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;

    th, td {
      border: 1.5px solid #000;
      padding: 10px 8px;
      text-align: center;
      vertical-align: middle;
      color: #000;
    }

    th {
      background-color: #fff;
      font-weight: 800;
      text-transform: uppercase;
      font-size: 0.75rem;
    }

    .font-weight-bold {
      font-weight: 700;
    }
  }

  .signature-section {
    margin-top: 3rem;

    .signature-label {
      font-weight: 700;
      font-size: 1.3rem;
      margin-bottom: 0.5rem;
      color: #000;
    }

    .signature-line {
      border-bottom: 1px solid #ddd;
      width: 100%;
      height: 1px;
    }
  }

  @media print {
    padding: 0;
    background-color: transparent;

    .top-action-bar,
    .header-navbar,
    .main-menu,
    .footer,
    .breadcrumb-wrapper {
      display: none !important;
    }

    .app-content,
    .content-wrapper,
    .content-body {
      padding: 0 !important;
      margin: 0 !important;
    }

    .voucher-card-printable {
      padding: 0 !important;
      box-shadow: none !important;
      max-width: 100% !important;
      margin: 0 !important;
      border: none !important;
    }

    .custom-print-table {
      th, td {
        border: 2px solid #000 !important;
        print-color-adjust: exact;
      }
    }

    // Ensure colors like text-danger (red) print correctly
    .text-danger {
      color: #ff0000 !important;
    }
  }
}
</style>
